class FundsStore {
  constructor() {
    /**
     * @type {Fund[]}
     */
    this.funds = [];

    this.fundFieldsFormSnapshot = [];

    this.currentSelectedFundTab = "";

    this.swpExpand = "";
    this.atsExpand = "";
    this.latestFund = [];
    this.investedFundValues = [];
    this.isDefaultFund= "";
  }

  addFund(fund) {
    this.funds.push(fund);
  }

  getFunds() {
    return this.funds;
  }

  setFunds(funds) {
    this.funds = funds;
  }

  getCurrentSelectedFundTab() {
    return this.currentSelectedFundTab;
  }

  setCurrentSelectedFundTab(currentSelectedFundTab) {
    this.currentSelectedFundTab = currentSelectedFundTab;
  }

  setswpExpand(swpExpandValue) {
    this.swpExpand = swpExpandValue;
  }
  getswpExpand() {
    return this.swpExpand;
  }
  setatsExpand(atsExpandValue) {
    this.atsExpand = atsExpandValue;
  }
  getatsExpand() {
    return this.atsExpand;
  }
  getLatestFund(){
    return this.latestFund;
  }
  setLatestFund(fund){
    this.latestFund=fund;
  }
  getInvestedFundValues(){
    return this.investedFundValues;
  }

  setInvestedFundValues(investedFundValues){
    this.investedFundValues = investedFundValues
  }

  getDefaultFund() {
    return this.isDefaultFund;
  }
  setDefaultFund(fund) {
    this.isDefaultFund = fund;
  }
}

export const fundsStoreInstance = new FundsStore();
